import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const Favorites = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'favorites' */
  './Favorites'
))

export function AsyncFavorites(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Favorites..." />}>
      <Favorites {...props} />
    </Suspense>
  )
}

export default AsyncFavorites
